import React from 'react';
import { Form, Input, Card } from 'antd';
import { useTemplate } from '../template.hook';
import { TemplateRequest } from '../../../../request/template.request';
import { validateAddressStreet, validateCity } from '../../../../validator/user-info.validator';
import { validateName } from '../../../../validator/user-info.validator';
import { useNavigate } from 'react-router-dom';

export const UpdateTemplateComponent: React.FC<{}> = () => {
    const navigate = useNavigate();

    const [form] = Form.useForm();
    const { loading, updateLoading, updateTemplate } = useTemplate()

    const template: any = {}

    const handleOk = () => {
        form.validateFields().then(values => {
            updateLoading(true);
            const templateRequest = {
                type: values["type"],
                title: values["title"],
                description: values["description"],
            } as TemplateRequest
            updateTemplate(template.id, templateRequest, onSuccess, onFailure)
        });
    };

    const onSuccess = () => {
        updateLoading(false);
        form.resetFields()
        navigate("/template");
    }

    const onFailure = () => {
        updateLoading(false);
    }

    return (
        <Card
            title="Update New Template"
            style={{ top: 8, maxWidth: 768 }}
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    name="type"
                    label="Type"
                    rules={[{ required: true, validator: validateName }]}
                    initialValue={template.type}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="title"
                    label="Title"
                    rules={[{ required: true, validator: validateAddressStreet }]}
                    initialValue={template.title}
                >
                    <Input.TextArea rows={2} placeholder="Enter title" />
                </Form.Item>
                <Form.Item
                    name="description"
                    label="Description"
                    rules={[{ required: true, validator: validateCity }]}
                    initialValue={template.description}
                >
                    <Input placeholder="Enter description" />
                </Form.Item>
            </Form>
        </Card>
    );
}